<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ dialogTitle }} - {{ username }} - {{ scheduleDate|date: "dd.MM.y": "UTC" }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">
                <div formArrayName="hours" *ngFor="let hour of hours().controls; index as i">
                    <div [formGroupName]="i">
                        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                            <mat-form-field appearance="outline" fxFlex="100" class="pr-6">
                                <mat-label>{{'Start hour'|translate}}</mat-label>
                                <input matInput formControlName="startHour" required>
                                <mat-error>{{'Hour is required and should be in format: HH:MM'|translate}}</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline" fxFlex="100" class="pr-6">
                                <mat-label>{{'End hour'|translate}}</mat-label>
                                <input matInput formControlName="endHour" required>
                                <mat-error>{{'Hour is required and should be in format: HH:MM'|translate}}</mat-error>
                            </mat-form-field>
                            <button (click)="removeHour(i)" mat-raised-button color="warn">{{'-'|translate}}</button>
                        </div>
                    </div>
                </div>

            <button type="button" (click)="addHour()" mat-raised-button color="primary">{{'Add hour'|translate}}</button>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Description'|translate}}</mat-label>
                    <textarea matInput formControlName="description" matAutosizeMinRows="4" matAutosizeMaxRows="80" matTextareaAutosize></textarea>
                </mat-form-field>
            </div>
        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
        <button
                mat-raised-button
                class="mr-8"
                aria-label="Delete"
                (click)="showConfirmEmployeeScheduleDeleteDialog(employeeSchedule)"
                color="warn"
        >
            {{'Delete'|translate}}
        </button>
        <button
                mat-raised-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-raised-button
                class="mr-8"
                (click)="matDialogRef.close(form)"
                aria-label="Save"
                color="primary"
        >
            {{'Save'|translate}}
        </button>

    </div>
</div>